export const findVehicleMarker = (
  markers: Record<string, uui.domain.ui.map.markers.Vehicle>,
  vehicleId: string,
): uui.domain.ui.map.markers.Vehicle | undefined => {
  const marker = markers[vehicleId]

  return marker
}
